import React from 'react';
import PropTypes from 'prop-types';
import Avatar from 'react-avatar';
import Tooltip from '@material-ui/core/Tooltip';
import './Avatar.scss';

const CustomAvatar = ({
	size, textSizeRatio, name, tooltip, src, width, height, alt, fullWidth
}) => {
	if (src !== '') {
		return (
			<Tooltip id="tooltip-top" title={tooltip} placement="bottom-start">
				<img
					className={`avatar img-avatar ${fullWidth ? 'full-img' : ''}`}
					src={src}
					width={width}
					height={height}
					alt={alt}
				/>
			</Tooltip>
		);
	}
	return (
		<Tooltip id="tooltip-top" title={tooltip} placement="bottom-start">
			<Avatar
				className="avatar"
				size={size}
				textSizeRatio={textSizeRatio}
				round
				name={name.replace(/&|-/g,'').split(' ').slice(0,2).join(' ')}
				src=""
			/>
		</Tooltip>
	);
};

CustomAvatar.propTypes = {
	size: PropTypes.number,
	textSizeRatio: PropTypes.number,
	name: PropTypes.string,
	tooltip: PropTypes.string,
	src: PropTypes.string,
	width: PropTypes.string,
	height: PropTypes.string,
	alt: PropTypes.string
};

CustomAvatar.defaultProps = {
	size: 50,
	textSizeRatio: 3,
	name: '',
	tooltip: '',
	src: '',
	width: '34',
	height: '34',
	alt: ''
};

export default CustomAvatar;



// WEBPACK FOOTER //
// ./common/Avatar/Avatar.js